// 9fbef606107a605d69c0edbcd8029e5d
import logger from '@tcp/core/src/utils/loggerInstance';
import accountNavigationAbstractor from '@tcp/core/src/services/abstractors/account/AccountNavigation/index.js';
import handler from '../../../handler';

/**
 * @const DataAbstractor
 *
 * @member - getData - responsible for fetching the data for left navigation.
 * @member - processData - responsible form processing the data and return to navigation bar.
 */
export const DataAbstractor = {
  getData: async (category, brand, country, channel, apiConfig) => {
    const lang = apiConfig.language !== 'en' ? apiConfig.language : '';
    return handler
      .fetchModuleDataFromGraphQL(
        {
          name: 'subNavigation',
          data: { category, brand, country, channel, lang, type: 'subNavigation' },
        },
        apiConfig
      )
      .then((response) => (response ? response.data : {}));
  },

  processData: async (data, category) => {
    if (Object.keys(data).length) {
      const subNavigation = data.subNavigation.map((item) => {
        const tempItem = Object.assign({}, item);
        if (Object.keys(tempItem.leafLink).length) {
          tempItem.leafLink.id = tempItem.leafLink.text.split(' ').join('-');
          tempItem.leafLink.component = tempItem.leafLink.text.split(' ').join('-');
          tempItem.leafLink.displayName = tempItem.leafLink.text;
        }
        return tempItem;
      });
      return {
        key: category,
        val: subNavigation,
      };
    }
    return {};
  },
};

const dataWrapFunc = (data) => {
  return {
    accountNavigation: data?.subNavigation,
  };
};

export const getNavigationData = async (category, brand, country, channel, apiConfig) => {
  const { getData, processData } = DataAbstractor;
  let response = {};

  try {
    const data = await getData(category, brand, country, channel, apiConfig);

    response =
      category === 'account-navigation-loyalty'
        ? await accountNavigationAbstractor.processData(dataWrapFunc(data))
        : await processData(data, category);
  } catch (error) {
    logger.error(error);
  }
  if (category === 'account-navigation-loyalty') {
    return {
      name: category,
      response,
    };
  }
  return response;
};
